import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getBugReports, updateBugStatus } from '../../services/(adminapi)/bugAPI'

// Async thunks
export const fetchBugReports = createAsyncThunk(
  'bug/fetchBugReports',
  async ({ params = {}, businessId = null }, { rejectWithValue }) => {
    try {
      const response = await getBugReports(params, businessId)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch bug reports')
    }
  }
)

export const updateBugReportStatus = createAsyncThunk(
  'bug/updateBugStatus',
  async ({ bugId, status }, { rejectWithValue }) => {
    try {
      const response = await updateBugStatus(bugId, status)
      return { bugId, status, response }
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to update bug status')
    }
  }
)

const initialState = {
  bugReports: [],
  loading: false,
  error: null,
  success: null
}

const bugSlice = createSlice({
  name: 'bug',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearSuccess: (state) => {
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch bug reports
      .addCase(fetchBugReports.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchBugReports.fulfilled, (state, action) => {
        state.loading = false
        state.bugReports = action.payload.data?.reports || []
        state.error = null
      })
      .addCase(fetchBugReports.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.bugReports = []
      })
      
      // Update bug status
      .addCase(updateBugReportStatus.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateBugReportStatus.fulfilled, (state, action) => {
        state.loading = false
        const bugId = action.payload.bugId
        const bugIndex = state.bugReports.findIndex(bug => bug.id === bugId)
        if (bugIndex !== -1) {
          state.bugReports[bugIndex].status = action.payload.status
        }
        state.success = 'Bug status updated successfully'
      })
      .addCase(updateBugReportStatus.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearError, clearSuccess } = bugSlice.actions
export default bugSlice.reducer

